module.exports = __webpack_public_path__ + "img/copy.fb91d3d7.svg";